import { render, staticRenderFns } from "./AppOpenSelect.vue?vue&type=template&id=2fca4e23&"
import script from "./AppOpenSelect.vue?vue&type=script&lang=js&"
export * from "./AppOpenSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports